import {getQuery, postQuery, removeQuery, putQuery} from "@/modules/common/utils";

const smsBasePath = 'business/messaging/v1/settings/';
const channelsBasePath = 'business/messaging/v1/channels/'

const getMessagingSettings = async () => {
  let result;
  try {
    result = await getQuery(smsBasePath, {new_api: true});
    result = result.data;
  } catch (error) {
    result = {code: 'error'};
  }
  return result;
};

const getPhoneNumbers = async () => {
  let result;
  try {
    result = await getQuery(channelsBasePath, {new_api: true, provider: 'nexmo'});
    result = result.data;
  } catch (error) {
    result = {code: 'error'};
  }
  return result;
};

const updateSettings = async (businessUid, params) => {
  let newParams = params || {};
  params.new_api = true;
  let result;
  try {
    result = await putQuery(smsBasePath+businessUid, newParams);
  } catch (error) {
    result = {code: 'error'};
  }
  return result;
};

const getTextingListItems = () => {
  return listItems;
};

const claimNumber = async (params) => {
  let newParams = params || {};
  newParams.new_api = true;
  newParams.channel = {provider: 'nexmo'};
  let result;
  try {
    result = await postQuery(channelsBasePath, newParams);
  } catch (error) {
    result = {code: 'error'};
  }
  result.data && (result = result.data.channel);
  return result;
};

const unclaimNumber = async (businessUid, params) => {
  let result;
  try {
    result = await removeQuery(channelsBasePath+businessUid, {new_api: true, params});
  } catch (error) {
    result = {code: 'error'};
  }
  return result;
};

const getFormattedNumber = (numberObject) => {
  const prefix = numberObject.number_obj[0];
  const number = numberObject.number_obj[1];

  return `+(${prefix}) ${number}`;
};

const getBusinessActiveDedicatedNumber = async () => {
  let res = await getPhoneNumbers();
  if (res.code && res.code === 'error') {
    return res;
  }
  if (Array.isArray(res.channels)) {
    return res.channels.find(number => number.number_type === "transactional" && number.status === "active") || null;
  }
  return null;
};

const listItems = [
  {
    icon: 'icon-check',
    iconColor: '#54d28c',
    iconSize: 16,
    textKey: 'settings.business_page.two-way-texting.item-1'
  },
  {
    icon: 'icon-check',
    iconColor: '#54d28c',
    iconSize: 16,
    textKey: 'settings.business_page.two-way-texting.item-2'
  },
  {
    icon: 'icon-check',
    iconColor: '#54d28c',
    iconSize: 16,
    textKey: 'settings.business_page.two-way-texting.item-3'
  },
  {
    icon: 'icon-check',
    iconColor: '#54d28c',
    iconSize: 16,
    textKey: 'settings.business_page.two-way-texting.item-4'
  },
  {
    icon: 'icon-check',
    iconColor: '#54d28c',
    iconSize: 16,
    textKey: 'settings.business_page.two-way-texting.item-5'
  },
  {
    icon: 'icon-Loyal',
    iconColor: '#ffc511',
    iconSize: 12,
    textKey: 'settings.business_page.two-way-texting.item-6'
  }
];

export const SmsSettingsService = {
  getMessagingSettings,
  getPhoneNumbers,
  updateSettings,
  getTextingListItems,
  unclaimNumber,
  claimNumber,
  getFormattedNumber,
  getBusinessActiveDedicatedNumber
}
